import type React from "react";
import { Label } from "@/components/ui/label";
import { RadioGroupItem } from "@/components/ui/radio-group";

type Props = {
	name: string;
	value: string;
	id: string;
	label: string;
	className?: string;
	handleChange: (id: string, name: string, ...args: unknown[]) => void;
	disabled?: boolean;
	otherProps?: React.HTMLAttributes<HTMLDivElement>;
};

export const RadioOption: React.FC<Props> = ({
	value,
	id,
	label,
	name,
	handleChange,
	disabled = false,
	className = "flex items-center space-x-2 w-1/2",
	otherProps,
}) => {
	function handleClick() {
		handleChange(id, name);
	}

	return (
		<div className={className} {...otherProps}>
			<RadioGroupItem
				value={value}
				id={id}
				aria-label={label}
				className="text-[--foreground] border-[--foreground] cursor-pointer gap-1"
				onClick={handleClick}
				disabled={disabled}
			/>
			<Label htmlFor={id} className="cursor-pointer text-base min-w-[180px]">
				{label}
			</Label>
		</div>
	);
};
